import { ApolloClient } from '@apollo/client'
import { cache } from './cache'

export const client = new ApolloClient({
  uri: 'https://api.dev.us-1.veritone.com/api/nft/graphql',
  cache,
})
